export default {
    member: [
        'View company APIs',
        'View licenses',
    ],
    admin: [
        'Create/edit/delete users',
        'Update company information',
        'Apply for licenses',
    ],
};



// WEBPACK FOOTER //
// ./src/components/profile/TeamMember/TeamMemberConstants.js